import { render, staticRenderFns } from "./userstorageconfig-list.vue?vue&type=template&id=689762de"
import script from "./userstorageconfig-list.vue?vue&type=script&lang=ts"
export * from "./userstorageconfig-list.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports